import { render, staticRenderFns } from "./convert-detail.vue?vue&type=template&id=2886005c&scoped=true"
import script from "./convert-detail.vue?vue&type=script&lang=js"
export * from "./convert-detail.vue?vue&type=script&lang=js"
import style0 from "./convert-detail.vue?vue&type=style&index=0&id=2886005c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2886005c",
  null
  
)

export default component.exports